import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/home/logo.png';
import _imports_1 from '@/assets/img/consultant/qr.jpg';
const _withScopeId = n => (_pushScopeId("data-v-4138f574"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bottom"
};
const _hoisted_2 = {
  class: "info"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"left\" data-v-4138f574><div data-v-4138f574><div class=\"left_top\" data-v-4138f574><img class=\"logo\" src=\"" + _imports_0 + "\" alt=\"\" data-v-4138f574><span class=\"title\" data-v-4138f574>四川京奇数据科技有限公司 </span></div><div class=\"line1\" data-v-4138f574></div><div class=\"text\" data-v-4138f574>办公地点</div><div class=\"text\" data-v-4138f574>总部地址：成都市高新区新中泰国际大厦A座2602</div><div class=\"text\" data-v-4138f574>商务合作：18640148662</div></div><div class=\"qrcode_box\" data-v-4138f574><img class=\"qrcode\" src=\"" + _imports_1 + "\" alt=\"\" data-v-4138f574><div class=\"text\" data-v-4138f574>添加合作微信</div></div></div>", 1);
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line2"
}, null, -1));
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "0 auto",
    "padding": "20px 0",
    "display": "flex",
    "align-items": "center",
    "width": "max-content"
  }
}, [/*#__PURE__*/_createElementVNode("p", null, "版权所有：四川京奇数据科技有限公司"), /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "http://beian.miit.gov.cn",
  style: {
    "display": "inline-block",
    "text-decoration": "none",
    "height": "20px",
    "line-height": "20px",
    "margin-left": "10px"
  }
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "float": "left",
    "height": "20px",
    "line-height": "20px",
    "margin": "0px 0px 0px 5px",
    "color": "#939393"
  }
}, " 蜀ICP备2024078957号-1 ")])])], -1));
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'Bottom',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const arr = [{
      name: '产品及服务',
      children: [{
        name: 'AI拓客'
      }, {
        name: '智悦拎包'
      }, {
        name: '智悦节能'
      }, {
        name: '合伙人招募'
      }
      // !isMobile() && {
      //   name: '获客学院',
      // },
      ]
    },
    // {
    //   name: '客户及案例',
    //   children: [
    //     {
    //       name: '地产行业',
    //     },
    //     {
    //       name: '家居行业',
    //     },
    //     {
    //       name: '家电行业',
    //     },
    //     {
    //       name: '装修行业',
    //     },
    //     {
    //       name: '本地生活',
    //     },
    //   ],
    // },
    {
      name: '关于我们',
      children: [{
        name: '京奇数据'
      }, {
        name: '联系我们'
      }]
    }];
    const toUrl = () => {
      router.push({
        name: 'login'
      });
    };
    const handleClick = name => {
      if (name === 'AI拓客') {
        router.push({
          name: 'marketing'
        });
      } else if (name === '智悦拎包') {
        router.push({
          name: 'package'
        });
      } else if (name === '智悦节能') {
        router.push({
          name: 'energy'
        });
      } else if (name === '获客学院') {
        router.push({
          name: 'zixun'
        });
      } else if (name === '合伙人招募') {
        router.push({
          name: 'partner'
        });
      } else if (['京奇数据', '企业文化', '发展历程'].includes(name)) {
        router.push({
          name: 'home'
        });
      } else if (name === '联系我们') {
        router.push({
          name: 'about'
        });
      } else {
        router.push({
          name: 'case'
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(arr, (item, i) => {
        return _createElementVNode("div", {
          class: "right_item",
          key: i
        }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1), _hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (opt, ind) => {
          return _openBlock(), _createElementBlock("div", {
            key: ind
          }, [_createElementVNode("div", {
            class: "text",
            onClick: $event => handleClick(opt.name)
          }, _toDisplayString(opt.name), 9, _hoisted_8)]);
        }), 128))]);
      }), 64))])]), _hoisted_9])])]);
    };
  }
});